import { atomWithStorage } from 'jotai/utils';

export const CAMPAING_STORAGE_KEY = 'precifield.campaign';
export const campaignAtom = atomWithStorage<number | undefined>(
  CAMPAING_STORAGE_KEY,
  undefined,
);
